import { lazy } from 'react';

export const PlayerDepositLimitsForm = lazy(
  () => import('./PlayerDepositLimitsForm'),
);
